import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { useEffect, useState, useLayoutEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { SITE, applySiteShell } from "./lib/site";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};
import Home from "./pages/Home";
import OrderTrack from "./pages/OrderTrack";
import AdminOrders from "./pages/AdminOrders";
import AdminHub from "./pages/AdminHub";
import AdminUsers from "./pages/AdminUsers";
import UniformOrder from "./pages/UniformOrder";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import PricingPolicy from "./pages/PricingPolicy";
import ProductDetail from "./pages/ProductDetail";
import Shop from "./pages/Shop";
import About from "./pages/About";
import AcademyAbout from "./pages/AcademyAbout";
import Collection from "./pages/Collection";
import AllCollections from "./pages/AllCollections";
import AdminOffers from "./pages/AdminOffers";
import ThankYou from "./pages/ThankYou";
import ProductCustomizer from "./pages/ProductCustomizer";
import CelebritiesInPRSVR from "./pages/CelebritiesInPRSVR";
import Academy from "./pages/Academy";
import AcademySuccess from "./pages/AcademySuccess";
import AcademyEnroll from "./pages/AcademyEnroll";
import AcademyStart from "./pages/AcademyStart";
import AcademyEnrollmentSuccess from "./pages/AcademyEnrollmentSuccess";
import AcademyDashboard from "./pages/AcademyDashboard";
import AcademyAdminPortal from "./pages/AcademyAdminPortal";
import AcademyLMS from "./pages/AcademyLMS";
import AcademyCreateAccount from "./pages/AcademyCreateAccount";
import AcademyLogin from "./pages/AcademyLogin";
import AcademyForgotPassword from "./pages/AcademyForgotPassword";
import AcademyResetPassword from "./pages/AcademyResetPassword";
import TeacherPortal from "./pages/TeacherPortal";
import TeacherDashboard from "./pages/TeacherDashboard";
import HighPerformanceDashboard from "./pages/HighPerformanceDashboard";
import FilmRoom from "./pages/FilmRoom";
import TheVault from "./pages/TheVault";
import WelcomeJan8 from "./pages/WelcomeJan8";
import LegacyDiagnostic from "./pages/LegacyDiagnostic";
import ParentDiagnostic from "./pages/ParentDiagnostic";
import AssessmentResults from "./pages/AssessmentResults";
import PerformersAudit from "./pages/PerformersAudit";
import ExecutiveReadinessReport from "./pages/ExecutiveReadinessReport";
import Electives from "./pages/Electives";
import ElectiveCourses from "./pages/ElectiveCourses";
import ElectiveCourse from "./pages/ElectiveCourse";
import ScholarPortfolio from "./pages/ScholarPortfolio";
import ParentWelcome from "./pages/ParentWelcome";
import FamilyHub from "./pages/FamilyHub";
import ElectiveReservationSuccess from "./pages/ElectiveReservationSuccess";
import NotFound from "./pages/NotFound";
import AdminCommunications from "./pages/AdminCommunications";
import TheCombine from "./pages/TheCombine";
import CombinePractice from "./pages/CombinePractice";
import GrandmasterSeries from "./pages/ThirtDaySprintEnrollment";
import Reclassification101 from "./pages/Reclassification101";
import TaylorCollection from "./pages/TaylorCollection";
import TunnelVisionExperience from "./pages/TunnelVisionExperience";
import ValleyCollectionExperience from "./pages/ValleyCollectionExperience";
import ValleyLeatherShop from "./pages/ValleyLeatherShop";
import LChaimLanding from "./pages/LChaimLanding";
import LChaimDashboard from "./pages/LChaimDashboard";
import LChaimPreview from "./pages/LChaimPreview";
import LChaimVault from "./pages/LChaimVault";
import Matrix from "./pages/Matrix";
import Dila from "./pages/Dila";
import DilaProduct from "./pages/DilaProduct";
import DilaItem from "./pages/DilaItem";
import Chila from "./pages/Chila";
import RoadToMichigan from "./pages/RoadToMichigan";
import AdminRun from "./pages/AdminRun";
import LChaimEnroll from "./pages/LChaimEnroll";
import LChaimCompanion from "./pages/LChaimCompanion";
import LChaimSuccess from "./pages/LChaimSuccess";
import LChaimLinkAccount from "./pages/LChaimLinkAccount";
import LChaimLogin from "./pages/LChaimLogin";
import TeamMerchHub from "./pages/TeamMerchHub";
import TeamOrdersAdmin from "./pages/TeamOrdersAdmin";
import ClientBrief from "./pages/ClientBrief";
import AdminInvoices from "./pages/AdminInvoices";
import HeyGenAdmin from "./pages/HeyGenAdmin";
import SchoolDashboard from "./pages/SchoolDashboard";
import AdminMorningReport from "./pages/AdminMorningReport";
import ParentPortal from "./pages/ParentPortal";
import LessonPage from "./pages/LessonPage";

// Launch date: January 8th, 2026 @ 9:00 AM EST
const LAUNCH_DATE = new Date('2026-01-08T09:00:00-05:00');

// Gated Launch Wrapper - redirects logged-in users to waiting room before launch
const GatedLaunchWrapper = ({ children }) => {
  const location = useLocation();
  const [isBeforeLaunch, setIsBeforeLaunch] = useState(true);
  
  useEffect(() => {
    const checkLaunch = () => {
      const now = new Date();
      setIsBeforeLaunch(now < LAUNCH_DATE);
    };
    
    checkLaunch();
    const interval = setInterval(checkLaunch, 1000);
    return () => clearInterval(interval);
  }, []);

  // Pages that should bypass the gated launch redirect
  const bypassPaths = [
    '/welcome-jan-8',
    '/academy/enroll',
    '/academy/login',
    '/academy/create-account',
    '/academy/enrollment/success',
    '/academy/success',
    '/academy/legacy-diagnostic',
    '/academy/assessment-results',
    '/academy/family',
    '/academy/welcome',
    '/academy', // Landing page
    '/', // Homepage
    '/shop',
    '/about',
    '/collections',
    '/celebrities',
    '/privacy-policy',
    '/terms-of-service',
    '/refund-policy',
    '/pricing-policy',
    '/products',
    '/customize',
    '/admin',
    '/thank-you'
  ];
  
  // Check if current path should bypass
  const shouldBypass = bypassPaths.some(path => 
    location.pathname === path || 
    location.pathname.startsWith(path + '/')
  );

  // If before launch and user is logged in and trying to access gated content
  if (isBeforeLaunch && !shouldBypass) {
    const token = localStorage.getItem('academy_token');
    const userStr = localStorage.getItem('academy_user');
    
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        const isEnrolled = user.is_student || user.payment_status === 'paid' || user.subscription_tier;
        
        // Only redirect enrolled users to waiting room
        if (isEnrolled) {
          return <Navigate to="/welcome-jan-8" replace />;
        }
      } catch (e) {
        // Invalid user data, let them through
      }
    }
  }

  return children;
};

// Suppress the global store Header/Footer on the DILA storefront, which has its
// own nav and its own Shopify-connected cart drawer.
const Chrome = ({ children }) => {
  const location = useLocation();
  const bare = location.pathname.startsWith('/dila') || location.pathname.startsWith('/chila') || location.pathname.startsWith('/road-to-michigan') || location.pathname.startsWith('/track') || location.pathname.startsWith('/admin/orders') || location.pathname.startsWith('/admin/run');
  return (
    <>
      {!bare && <Header />}
      <main className={`flex-1 ${bare ? '' : 'pt-16'}`}>{children}</main>
      {!bare && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => { applySiteShell(); }, []);
  return (
    <div className="App min-h-screen flex flex-col" style={{ overflowX: 'hidden', overflowY: 'visible' }}>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Chrome>
          <Routes>
            <Route path="/" element={SITE.isSchool ? <Navigate to="/academy" replace /> : <Matrix />} />
            <Route path="/heritage" element={<Home />} />
            <Route path="/home-legacy" element={<Navigate to="/heritage" replace />} />
            <Route path="/sports" element={<UniformOrder />} />
            <Route path="/saa" element={<Academy />} />
            <Route path="/track/:token" element={<OrderTrack />} />
            <Route path="/admin" element={<AdminHub />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/collections" element={<AllCollections />} />
            <Route path="/collections/taylor" element={<TaylorCollection />} />
            <Route path="/collections/tunnel-vision" element={<TunnelVisionExperience />} />
            <Route path="/collections/valley" element={<ValleyCollectionExperience />} />
            <Route path="/collections/valley-track-suit" element={<ValleyLeatherShop />} />
            <Route path="/collections/:handle" element={<Collection />} />
            <Route path="/uniform-order" element={<UniformOrder />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/pricing-policy" element={<PricingPolicy />} />
            <Route path="/products/:handle" element={<ProductDetail />} />
            <Route path="/customize/:handle" element={<ProductCustomizer />} />
            <Route path="/celebrities" element={<CelebritiesInPRSVR />} />
            
            {/* Academy Routes */}
            <Route path="/academy" element={<Academy />} />
            <Route path="/academy/login" element={<AcademyLogin />} />
            <Route path="/academy/forgot-password" element={<AcademyForgotPassword />} />
            <Route path="/academy/reset-password" element={<AcademyResetPassword />} />
            <Route path="/academy/teacher" element={<TeacherPortal />} />
            <Route path="/teacher-dashboard" element={<TeacherDashboard />} />            <Route path="/academy/success" element={<AcademySuccess />} />
            <Route path="/academy/enroll" element={<AcademyStart />} />
            <Route path="/academy/start" element={<AcademyStart />} />
            <Route path="/academy/enroll-paid" element={<AcademyEnroll />} />
            <Route path="/academy/enrollment/success" element={<AcademyEnrollmentSuccess />} />
            <Route path="/academy/lms" element={<AcademyLMS />} />
            <Route path="/academy/school" element={<SchoolDashboard />} />
            <Route path="/academy/lesson/:courseId/:moduleId" element={<LessonPage />} />
            <Route path="/academy/parent" element={<ParentPortal />} />
            <Route path="/academy/admin-portal" element={<AcademyAdminPortal />} />
            <Route path="/academy/create-account" element={<AcademyCreateAccount />} />
            
            {/* L'Chaim Routes */}
            <Route path="/academy/lchaim" element={<LChaimLanding />} />
            <Route path="/team/:teamSlug" element={<TeamMerchHub />} />
            <Route path="/admin/team-orders" element={<TeamOrdersAdmin />} />
            <Route path="/academy/lchaim/login" element={<LChaimLogin />} />
            <Route path="/academy/lchaim/dashboard" element={<LChaimDashboard />} />
            <Route path="/academy/lchaim/preview/:chord/:day" element={<LChaimPreview />} />
            <Route path="/academy/lchaim/vault" element={<LChaimVault />} />
            <Route path="/matrix" element={<Matrix />} />
            <Route path="/dila" element={<Dila />} />
            <Route path="/dila/item/:handle" element={<DilaItem />} />
            <Route path="/dila/:handle" element={<DilaProduct />} />
            <Route path="/chila" element={<Chila />} />
            <Route path="/road-to-michigan" element={<RoadToMichigan />} />
            <Route path="/admin/run" element={<AdminRun />} />
            <Route path="/academy/lchaim/enroll" element={<LChaimEnroll />} />
            <Route path="/academy/lchaim/companion" element={<LChaimCompanion />} />
            <Route path="/academy/lchaim/success" element={<LChaimSuccess />} />
            <Route path="/academy/lchaim/link-account" element={<LChaimLinkAccount />} />
            
            {/* Client Brief Routes */}
            <Route path="/client-brief" element={<ClientBrief />} />
            <Route path="/admin-invoices" element={<AdminInvoices />} />
            
            {/* Gated Launch - Waiting Room */}
            <Route path="/welcome-jan-8" element={<WelcomeJan8 />} />
            
            {/* Legacy Diagnostic & Assessment Results */}
            <Route path="/academy/legacy-diagnostic" element={<LegacyDiagnostic />} />
            <Route path="/academy/diagnostic" element={<LegacyDiagnostic />} />
            <Route path="/academy/parent-diagnostic" element={<ParentDiagnostic />} />
            <Route path="/academy/assessment-results" element={<AssessmentResults />} />
            <Route path="/academy/performers-audit" element={<PerformersAudit />} />
            <Route path="/academy/executive-report" element={<ExecutiveReadinessReport />} />
            
            {/* Academy About Page */}
            <Route path="/academy/about" element={<AcademyAbout />} />
            <Route path="/academy/reclassification-101" element={<Reclassification101 />} />
            
            {/* Electives */}
            <Route path="/academy/electives" element={<Electives />} />
            <Route path="/academy/electives/success" element={<ElectiveReservationSuccess />} />
            <Route path="/academy/elective-courses" element={<ElectiveCourses />} />
            <Route path="/academy/elective-courses/:courseId" element={<ElectiveCourse />} />
            <Route path="/academy/portfolio/:slug" element={<ScholarPortfolio />} />
            <Route path="/academy/welcome" element={<ParentWelcome />} />
            <Route path="/academy/family" element={<FamilyHub />} />
            <Route path="/academy/family/:token" element={<FamilyHub />} />
            
            {/* Gated Academy Content - redirects to waiting room before launch */}
            <Route path="/academy/dashboard" element={<Navigate to="/academy/school" replace />} />
            <Route path="/student-dashboard" element={<Navigate to="/academy/school" replace />} />
            <Route path="/academy/high-performance" element={
              <GatedLaunchWrapper>
                <HighPerformanceDashboard />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/film-room" element={
              <GatedLaunchWrapper>
                <FilmRoom />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/vault" element={
              <GatedLaunchWrapper>
                <TheVault />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/combine" element={
              <GatedLaunchWrapper>
                <CombinePractice />
              </GatedLaunchWrapper>
            } />
            <Route path="/academy/grandmaster" element={
              <GatedLaunchWrapper>
                <GrandmasterSeries />
              </GatedLaunchWrapper>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/offers" element={<AdminOffers />} />
            <Route path="/admin/communications" element={<AdminCommunications />} />
            <Route path="/admin/heygen" element={<HeyGenAdmin />} />
            <Route path="/admin/morning-report" element={<AdminMorningReport />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Chrome>
        </BrowserRouter>
        <Toaster position="top-right" />
      </CartProvider>
    </div>
  );
}

export default App;
